module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-2@3x.jpg?02501524";